<template>
  <div>
    <v-container
      v-if="!oneline"
      class="ma-0 pa-0"
      fluid
      style="background: var(--v-background2-base)"
    >
      <v-row
        align="start"
        justify="start"
        no-gutters
      >
        <v-col
          v-for="(item,index) in editorMenuList"
          :key="index"
          class="pa-0 ma-0 mr-1"
          style="height:44px;max-width: 100px;"
        >
          <v-btn
            v-if="isAddedSasie(item)"
            v-shortkey="index<10 ? ['ctrl', index+1] : null"
            class="ma-0 mt-2 pa-0 pb-1 align-end"
            style="height: 28px;"
            text
            @click="onClickMenu(item)"
            @shortkey="onClickMenu(item)"
          >
            <img
              v-if="item.icon"
              :src="getImgUrl(item.icon)"
            >
            <div
              v-else
              style="color:var(--v-textcolor-base); font-size: 16px; line-height: 1.0em;overflow:hidden;text-overflow:ellipsis;word-wrap: break-word;width: 100px;white-space:nowrap;"
            >
              {{ item.label }}
            </div>
          </v-btn>
        </v-col>
        <v-col style="max-width: 66px;height:44px;">
          <v-btn
            class="mx-4 mt-2"
            icon
            style="height: 28px;"
            @click="quickmenuDialogs.quickmenuDialog = true"
          >
            <v-icon color="textcolor">
              mdi-cog
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <div
      v-if="oneline"
      class="scrollmenu pb-3 pt-2"
      :style="{ width: scrollWidth + 'px' }"
    >
      <!--<template v-if="$vuetify.breakpoint.mdAndUp">-->
      <template v-for="(item,index) in editorMenuList">
        <v-btn
          v-if="isAddedSasie(item)"
          :key="index"
          v-shortkey="index<10 ? ['ctrl', index+1] : null"
          class=" ma-0  pa-0  align-end"
          style="height: 23px;"
          text
          @click="onClickMenu(item)"

          @shortkey="onClickMenu(item)"
        >
          <img
            v-if="item.icon"
            :src="getImgUrl(item.icon)"
            style="max-height: 23px;"
          >
          <div
            v-else
            style="color:var(--v-textcolor-base); font-size: 16px; line-height: 1.0em"
          >
            {{ item.label }}
          </div>
        </v-btn>
      </template>
      <v-btn
        class="ma-0 mt-1  pa-0 "
        icon
        style="height: 20px;"
        @click="quickmenuDialogs.quickmenuDialog = true"
      >
        <v-icon color="textcolor">
          mdi-cog
        </v-icon>
      </v-btn>
      <!--</template>-->
    </div>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          傍点設定
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-text-field
              ref="bow_text"
              v-model="bowText"
              filled
              label="親文字（メインとなる文字）を入力"
            />
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            キャンセル
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="onClickBowDialogSuccess"
          >
            設定する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="templateDialog"
      max-width="780"
    >
      <Template @onClickText="onClickTemplate" />
    </v-dialog>

    <v-dialog
      v-model="imageDialog"
      max-width="450"
    >
      <v-card class="mx-auto">
        <v-card-title>
          挿絵URLを入力
        </v-card-title>

        <v-card-subtitle class="mt-3">
          画像のURLを入力<br>※みてみん様のみしか使えません<br>
        </v-card-subtitle>
        <div class="text-center">
          <a
            href="https://mitemin.net/imageupload/input/"
            target="_blank"
          >みてみん様のサイトを開く</a>
        </div>
        <v-col>
          <v-text-field
            ref="insert_image_text"
            v-model="miteminUrl"
            filled
            hint="例）https://ユーザID.mitemin.net/iコード/"
          />
        </v-col>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="imageDialog=false"
              >
                キャンセル
              </v-btn>

              <v-btn
                text
                @click="onClickInsertImage"
              >
                設定する
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="imageErrorDialog"
      max-width="450"
    >
      <v-card class="mx-auto">
        <v-card-title>
          エラー
        </v-card-title>

        <v-card-subtitle class="mt-3">
          不正なURLです<br>
          ※みてみん様のURLを入力してください<br>
          <br>
          例）https://23.mitemin.net/i3724/
        </v-card-subtitle>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="imageErrorDialog=false"
              >
                閉じる
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <quick-menu-setting-dialog :dialogs="quickmenuDialogs" />
  </div>
</template>

<script>
import config from "@/const";
import Template from '../component/Template.vue';
import {mapState} from "vuex";
import QuickMenuSettingDialog from "../component/QuickMenuSettingDialog.vue";

export default {
  name: "EditorMenu",
  components: {
    Template,
    QuickMenuSettingDialog
  },
  props: ["executeInput", "siteType", "textArea", "oneline", "onClickBack", "onClickNext", "inputText", "scrollWidth"],
  data() {
    return {
      quickmenuDialogs: {
        quickmenuDialog: false,
      },
      dialog: false,
      templateDialog: false,
      imageDialog: false,
      imageErrorDialog: false,
      bowText: '',
      miteminUrl: '',
      kigou: config.KIGOU,
    }
  },
  computed: {
    ...mapState({
      editorMenuList: state => state.EditorMenuModule.EditorMenu.filter((element) => element.visible).sort((a, b) => {
        if(a.orderIndex<b.orderIndex) return -1;
        if(a.orderIndex>b.orderIndex) return 1;
        return 0;
      })
    })
  },
  mounted() {
  },
  methods: {
    getImgUrl(pic) {
      return require('../' + pic)
    },
    onClickMenu(item) {
      switch (item.type) {
        case config.EDITOR_MENU_TYPE.BACK:
          return this.onClickBack()
        case config.EDITOR_MENU_TYPE.FORWARD:
          return this.onClickNext()
        case config.EDITOR_MENU_TYPE.SASIE:
          return this.imageDialog = true
        case config.EDITOR_MENU_TYPE.KAKKO:
          return this.onClickKigou(config.KIGOU.kakko)
        case config.EDITOR_MENU_TYPE.KAKKO_ZEN:
          return this.onClickKigou(config.KIGOU.dai_kakko)
        case config.EDITOR_MENU_TYPE.KAKKO_JA:
          return this.onClickKigou(config.KIGOU.kagi_kakko)
        case config.EDITOR_MENU_TYPE.RUBY:
          return this.onClickRubi()
        case config.EDITOR_MENU_TYPE.BOUTEN:
          return this.onClickBow()
        case config.EDITOR_MENU_TYPE.TEMPLATE:
          return this.templateDialog = true
        case config.EDITOR_MENU_TYPE.PURE_TEXT:
          return this.onClickKigou(item.inputValue, item.inputValue.length)
      }
    },
    isAddedSasie(item){
      if(item.type === config.EDITOR_MENU_TYPE.RUBY || item.type===config.EDITOR_MENU_TYPE.BOUTEN){
        if((this.siteType.rubiFormat)){
          return true;
        }
        return false;
      }

      if(item.type === config.EDITOR_MENU_TYPE.SASIE){
        if(this.siteType.enableimage){
          return true;
        }
        return false;
      }
      return true;
    },
    /**
     * 挿絵挿入クリック
     */
    onClickInsertImage() {
      const reg = new RegExp('https://([0-9]*).mitemin.net/(.*)/');
      if(!this.miteminUrl.match(reg)){
        this.imageErrorDialog = true;
        return;
      }

      this.imageDialog = false;
      try {
        const url = new URL(this.miteminUrl);
        const number = url.host.split('.')[0];
        const subDomain = url.pathname.replace(/\//g, '');
        const addText = `<${subDomain}|${number}>`;

        let pos = this.textArea.selectionStart + addText.length;
        this.executeInput(addText, pos, pos);

      } catch (e) {
        setTimeout(() => {
          this.textArea.focus();
        }, 300);
      }
      this.miteminUrl = '';
    },
    /**
     * 記号関連クリック
     * @param kigou
     * @param position
     */
    onClickKigou(kigou, position = 1) {
      // 小説家になろうに()対応
      if ((this.siteType.value === 0 || this.siteType.value === 1 || this.siteType.value === 6) &&
          kigou == this.kigou.dai_kakko || kigou == this.kigou.kakko) {
        position = 2;
        kigou = `｜${kigou}`
      }
      let pos = this.textArea.selectionStart + position;
      this.executeInput(kigou, pos, pos);
    },
    /**
     * ルビクリック
     */
    onClickRubi() {
      const start = this.textArea.selectionStart;
      const end = this.textArea.selectionEnd;
      const trimText = start === end ? '' : this.inputText.substring(start, end);
      const format = this.siteType.rubiFormat;
      const movePosition = start === end ?
          format.prefix.length : `${format.prefix}${format.middle}`.length;
      const addText = `${format.prefix}${trimText}${format.middle}${format.suffix}`;
      const position = start + trimText.length + movePosition;
      this.executeInput(addText, position, position);
    },
    /**
     * 傍点クリック
     */
    onClickBow() {
      const start = this.textArea.selectionStart;
      const end = this.textArea.selectionEnd;

      // 範囲指定未選択の場合傍点対象の文字列検索ダイアログを表示
      if (start === end) {
        this.dialog = true;
        setTimeout(() => {
          this.$refs.bow_text.focus();
        }, 300);
        return;
      }

      const trimText = this.inputText.substring(start, end);
      const trimTextLength = trimText.length;
      let bowText = '';
      for (let i = 0; i < trimTextLength; i++) {
        bowText += "・";
      }
      if(this.siteType.boutenFormat){
        const format = this.siteType.boutenFormat;
        const movePosition = `${format.prefix}${format.suffix}`.length;
        const text = `${format.prefix}${trimText}${format.suffix}`;
        const position = start + movePosition;
        this.executeInput(text, position, position);
      }else{
        const format = this.siteType.rubiFormat;
        const movePosition = `${format.prefix}${format.middle}${format.suffix}`.length;
        const text = `${format.prefix}${trimText}${format.middle}${bowText}${format.suffix}`;
        const position = start + (trimTextLength * 2) + movePosition;
        this.executeInput(text, position, position);
      }

    },
    /**
     * 傍点ダイアログクリック
     */
    onClickBowDialogSuccess() {
      this.dialog = false;
      setTimeout(() => {
        const trimTextLength = this.bowText.length;
        let bowText = '';
        for (let i = 0; i < trimTextLength; i++) {
          bowText += "・";
        }

        if(this.siteType.boutenFormat){
          const format = this.siteType.boutenFormat;
          const text = `${format.prefix}${this.bowText}${format.suffix}`;
          const cursorEnd = this.textArea.selectionStart + text.length;
          this.executeInput(text, cursorEnd, cursorEnd);
        }else {
          const format = this.siteType.rubiFormat;
          const text = `${format.prefix}${this.bowText}${format.middle}${bowText}${format.suffix}`;
          const cursorEnd = this.textArea.selectionStart + text.length;
          this.executeInput(text, cursorEnd, cursorEnd);
        }
        this.bowText = '';
      }, 300);
    },
    /**
     * 定型文のリストクリックイベント
     * @param item
     */
    onClickTemplate(item) {
      this.templateDialog = false;
      if (item) {
        const cursor = this.textArea.selectionStart + item.label.length;
        this.executeInput(item.label, cursor, cursor);
      }
    },
    onClickImageInsert() {
      this.imageDialog = true;
      setTimeout(() => {
        this.$refs.insert_image_text.focus();
      }, 300);
    },
  }
}
</script>

<style scoped>
div.scrollmenu {
  background-color: var(--v-background2-base);
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
</style>
